<template>
  <out-layout>
    <header slot="form-header" class="header">
      <h3 class="title">Alterar senha</h3>
    </header>

    <fieldset slot="form-content" class="fieldset">
      <v-form>
        <v-text-field
          name="login"
          v-model="new_password"
          :min-lengh="6"
          label="Nova Senha"
          type="password">
        </v-text-field>

        <v-text-field
          name="login"
          v-model="confirmation_password"
          :min-lengh="6"
          label="Confirmar Nova Senha"
          type="password">
        </v-text-field>
      </v-form>

      <v-card-actions class="action">
        <v-btn large color="success"
               :disabled="passwordInvalid()"
               v-on:click="updatePassword()">
          Confirmar
        </v-btn>
      </v-card-actions>
    </fieldset>

    <template slot="navigation">
      <v-btn flat small color="primary" class="link" :to="{name: 'requerenteSignIn' }">
        <v-icon left>mdi-account-circle</v-icon>
        <span class="text">Voltar ao login</span>
      </v-btn>
    </template>
  </out-layout>
</template>

<script>
import OutLayout from '@/layouts/OutLayout';
import UserService from '@/services/UserService';
import AdminService from '@/services/applications/configurations/AdminService';

export default {
  name: 'UpdatePassword',
  components: {
    OutLayout,
  },
  data() {
    return {
      new_password: '',
      confirmation_password: '',
      token: this.$route.query.reset_password_token,
    };
  },
  methods: {
    updatePassword() {
      this.$store.dispatch('setLoadingDialog', true);
      let teste = null;
      const userParams = {
        token: this.token,
        password: this.new_password,
      };

      if (this.isAdmin){
        teste = this.updatePasswordAdmin(userParams)
      } else {
        teste = this.updatePasswordRequerente(userParams)
      }

      teste
        .then(() => {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'success',
          message: 'Senha alterada com sucesso',
          messageIcon: 'mdi-check',
        });
        this.$router.push({ name: (this.isAdmin ? 'AdminSignIn': 'requerenteSignIn') });
      })
        .catch(({ response }) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'error',
            message: response.data.join(', '),
            messageIcon: 'mdi-alert-circle',
          });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    passwordInvalid() {
      return (this.new_password !== this.confirmation_password) || (this.new_password.length <= 5);
    },
    updatePasswordRequerente(userParams){
      return UserService.resetPassword(userParams)
    },
    updatePasswordAdmin(userParams){
      return AdminService.resetPassword(userParams)
    }
  },
  computed: {
    isAdmin(){
      return this.$route.meta.userType === 'Admin'
    }
  }
};
</script>

<style scoped lang="scss">
</style>
